import { render, staticRenderFns } from "./ResearchAreaCard.vue?vue&type=template&id=5eb76712&scoped=true&"
import script from "./ResearchAreaCard.vue?vue&type=script&lang=ts&"
export * from "./ResearchAreaCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResearchAreaCard.vue?vue&type=style&index=0&id=5eb76712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb76712",
  null
  
)

export default component.exports